module.exports = __webpack_public_path__ + "img/Small-Vertical-Rectangular-Attachment-14.9dc35800.png";